import React from 'react';

import { languageName } from '../../../../config/languageEndonyms';
import { Root } from './FieldTag.styles';

export type FieldTagKind = 'platform-default' | 'edited' | 'using-default-language' | 'changed-by-platform';

export type FieldTagProps = {
  kind: FieldTagKind;
  /** The default language's code, for `using-default-language` ("Using English"). */
  language?: string;
};

/** Where a field's value comes from: the platform, the owner, the default language, or a platform change since the
 *  owner's last publish. */
export const FieldTag = ({ kind, language = '' }: FieldTagProps): React.ReactElement => {
  switch (kind) {
    case 'platform-default':
      return <Root text="Platform default" tag="span" $kind={kind} />;
    case 'edited':
      return <Root text="Edited" tag="span" $kind={kind} />;
    case 'using-default-language':
      return (
        <Root text="Using {{language}}" placeholders={{ language: languageName(language) }} tag="span" $kind={kind} />
      );
    case 'changed-by-platform':
      return <Root text="Changed by the platform since your last publish" tag="span" $kind={kind} />;
  }
};

export default FieldTag;
